module.exports = __webpack_public_path__ + "img/CIF.30b2efbc.png";